import { selfAxios } from "../../../../axios/selfAxios.js";
async function postGenerateMajorId() {
  const res = await selfAxios.post(`/quotation/designQuotationResultController/generateMajorId`);
  return res.data.data;
}
export { postGenerateMajorId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/quotation/designQuotationResultController/generateMajorId/post.js